(function () {
  'use strict';
  if (customElements.get('ellaya-related-slider')) return;

  class EllayaRelatedSlider extends HTMLElement {
    connectedCallback() { this._tries = 0; this.init(); }
    disconnectedCallback() { if (this.swiper) { this.swiper.destroy(true, true); this.swiper = null; } }

    init() {
      if (this.swiper) return;
      if (typeof window.Swiper === 'undefined') {
        if (this._tries++ > 60) return;
        window.requestAnimationFrame(() => this.init());
        return;
      }
      var root = this.closest('.eyml') || this;
      this.swiper = new window.Swiper(this, {
        slidesPerView: 1,         
        spaceBetween: 16,
        grabCursor: true,
        watchOverflow: true, 
        pagination: {
  el: (this.closest('.eyml') || this).querySelector('.eyml__pagination'),
  clickable: true
},
        // freeMode: { enabled: true, sticky: false, momentumBounce: false },
        mousewheel: { forceToAxis: true, releaseOnEdges: true, sensitivity: 1 },
        keyboard: { enabled: true, onlyInViewport: true },
        a11y: { enabled: true },
        navigation: {
          prevEl: root.querySelector('[data-eyml-prev]'),
          nextEl: root.querySelector('[data-eyml-next]')
        }
      });
    }
  }

  customElements.define('ellaya-related-slider', EllayaRelatedSlider);
})();